module.exports = __webpack_public_path__ + "img/tassei.cc4a3d96.png";